import "../dataset-style.scss";

import {
  CAlert,
  CButton,
  CCard,
  CCardBody,
  CCardFooter,
  CCol,
  CForm,
  CFormGroup,
  CInput,
  CInputRadio,
  CLabel,
  CRow,
  CSelect,
} from "@coreui/react";
import StyledDropzone, { UploadToDatasetHeader } from "./Dropzone";
import {
  putTempPersistTabular,
  syncCsv,
  syncCsvDetails,
} from "../services/DatasetServices";

import CIcon from "@coreui/icons-react";
import { Can } from "src/helpers/Auth";
import { Loading } from "src/reusable/LoadingSpinner";
import LoadingOverlay from "react-loading-overlay-ts";
import { PropTypes } from "prop-types";
import React from "react";
import { freeSet } from "@coreui/icons";
import { useParams } from "react-router-dom";
import useDatasetViewerNavigation from "src/reusable/hooks/useDatasetViewerNavigation";
import { ACCEPTED_FILE_TYPES } from "src/constants";

const TabularFileUploader = (props) => {
  const [uploadFile, setUploadFile] = React.useState(null);
  const [csvUploadData, setCsvUploadData] = React.useState(null);
  const [uploadType, setUploadType] = React.useState("primary");
  const [updateDetailColumnName, setUpdateDetailColumnName] =
    React.useState("");
  const [isPutTempPersistCsvLoading, setIsPutTempPersistCsvLoading] =
    React.useState(false);
  const [putTempPersistCsvStatus, setPutTempPersistCsvStatus] =
    React.useState("idle");
  const [isPutTempPersistCsvError, setIsPutTempPersistCsvError] =
    React.useState(false);
  const [putTempPersistCsvError, setPutTempPersistCsvError] =
    React.useState(null);
  const [uniqueIdColumn, setUniqueIdColumn] = React.useState(null);
  const [syncCsvData, setSyncCsvData] = React.useState(false);
  const [isSyncCsvDataLoading, setIsSyncCsvDataLoading] = React.useState(false);
  const [syncCsvDataStatus, setSyncCsvDataStatus] = React.useState("idle");
  const [isSyncCsvDataError, setIsSyncCsvDataError] = React.useState(false);
  const [syncCsvDataError, setSyncCsvDataError] = React.useState(null);
  const { dataset_id } = useParams();

  const navigateToDataset = useDatasetViewerNavigation({
    datasetId: dataset_id,
    datasetFolderId: props.dataset?.dataset_folder_id,
  });

  return (
    <CCard>
      {props.titleHide ? <></> : <UploadToDatasetHeader />}
      <Can
        perform="dataset:write"
        // TODO: Fix Eslint complexity

        yes={() => (
          <LoadingOverlay
            active={isPutTempPersistCsvLoading || isSyncCsvDataLoading}
            spinner={<Loading height={"75em"} width={"75em"} />}
            text="Loading..."
          >
            <div style={{ minHeight: "100px" }}>
              {isPutTempPersistCsvError && (
                <CAlert color="danger">{String(putTempPersistCsvError)}</CAlert>
              )}

              {putTempPersistCsvStatus === "idle" && (
                <CForm
                  method="PUT"
                  encType="multipart/form-data"
                  onSubmit={(e) => {
                    e.preventDefault();
                    setCsvUploadData(null);
                    setIsPutTempPersistCsvLoading(true);
                    setPutTempPersistCsvStatus("loading");
                    setIsPutTempPersistCsvError(false);
                    setPutTempPersistCsvError(null);

                    putTempPersistTabular(
                      uploadFile,
                      (response) => {
                        // success
                        setCsvUploadData(response.data);
                        setIsPutTempPersistCsvLoading(false);
                        setPutTempPersistCsvStatus("success");
                        setIsPutTempPersistCsvError(false);
                        setPutTempPersistCsvError(null);
                      },
                      (error) => {
                        // error
                        setCsvUploadData(null);
                        setIsPutTempPersistCsvLoading(false);
                        setPutTempPersistCsvStatus("error");
                        setIsPutTempPersistCsvError(true);
                        setPutTempPersistCsvError(
                          error?.response?.data?.detail,
                        );
                      },
                    );
                  }}
                >
                  <CCardBody>
                    <CRow>
                      <CCol md="12">
                        <StyledDropzone
                          acceptsMultipleFiles={false}
                          showFileAcceptedMessage={true}
                          showFileRejectionMessage={true}
                          acceptTypeString={ACCEPTED_FILE_TYPES.MIME_TYPES.CSV}
                          titleMessage="Drag and drop or click to upload a .CSV or .XLSX file"
                          detailMessage="Please upload a CSV/XLSX file, UTF-8 encoding is expected for CSV files."
                          onDragSuccess={(file) => {
                            console.log("ondragsuccess");
                            console.log(file + "success");
                            setUploadFile(file);
                          }}
                          onDragFailed={(file) => {
                            console.log(file + "failed.");
                          }}
                        />
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol md="3">
                        <br />
                        <CButton
                          type="submit"
                          color="primary"
                          disabled={!uploadFile}
                          data-attr="datasets:btn:upload-tabular-file"
                        >
                          Upload
                        </CButton>
                      </CCol>
                    </CRow>
                  </CCardBody>
                </CForm>
              )}
              {putTempPersistCsvStatus === "success" &&
                syncCsvDataStatus === "idle" && (
                  <>
                    <CCardBody>
                      <h3>{csvUploadData.n_rows} rows uploaded</h3>
                      <CForm style={{ paddingTop: "5px" }}>
                        <CFormGroup row>
                          <CCol md="3">
                            <CLabel>
                              Are you creating or updating entire rows, or
                              adding a one-to-many detail?
                            </CLabel>
                          </CCol>
                          <CCol md="3">
                            <div style={{ display: "flex" }}>
                              <div
                                style={{ width: "40px", marginRight: "10px" }}
                              >
                                {uploadType === "primary" ? (
                                  <CIcon
                                    content={freeSet.cilList}
                                    width={35}
                                    height={35}
                                  />
                                ) : (
                                  uploadType === "detail" && (
                                    <img
                                      src="/images/one-to-many.png"
                                      width={35}
                                      height={35}
                                    />
                                  )
                                )}
                              </div>
                              <CSelect
                                name="uploadType"
                                value={uploadType}
                                data-attr="datasets:select:upload-type"
                                onChange={(e) => {
                                  setUploadType(e.target.value);
                                }}
                              >
                                <option value="primary">Rows</option>
                                <option value="detail">
                                  One-to-Many Details (deprecated)
                                </option>
                              </CSelect>
                            </div>
                          </CCol>
                          <CCol md="5">
                            <p style={{ fontSize: "85%" }}>
                              <i>
                                {uploadType === "primary" ? (
                                  <>
                                    Inserts a row into the dataset if no row
                                    with a matching unique identifier is found.
                                    If a row with a matching unique identifier
                                    is found, updates the row with the new data.
                                  </>
                                ) : (
                                  uploadType === "detail" && (
                                    <>
                                      Updates an existing row and sets the value
                                      of a column to a list containing all
                                      matching rows in the uploaded csv. Use to
                                      store details such as all the parts for a
                                      piece of equipment, or all the employees
                                      reporting to a manager.
                                    </>
                                  )
                                )}
                              </i>
                            </p>
                          </CCol>
                        </CFormGroup>
                        {uploadType === "detail" && (
                          <CAlert color="warning">
                            <b>Warning:</b> The &quot;One-to-Many Details&quot;
                            update feature is deprecated and will be removed in
                            v1.10. Please consider using ETL jobs to update
                            one-to-many details.
                            <br />
                            While this &quot;One-to-Many Detail&quot; operation
                            will still update the detailed data, it will now
                            forcibly update all records with the uploaded detail
                            data. <br />
                            Any subsequent updates (via ETL, One-to-Many, or
                            API) to these records will have the same effect.
                          </CAlert>
                        )}
                        {uploadType === "detail" && (
                          <CFormGroup row>
                            <CCol md="3">
                              <CLabel>
                                What column should the one-to-many details by
                                stored in?
                              </CLabel>
                            </CCol>
                            <CCol md="3">
                              <CInput
                                id="update-detail-name-input"
                                type="text"
                                name="update-detail-name"
                                placeholder="Name"
                                value={updateDetailColumnName}
                                onChange={(e) =>
                                  setUpdateDetailColumnName(e.target.value)
                                }
                              />
                            </CCol>
                          </CFormGroup>
                        )}
                        {/* TODO: add warnings for different columns and stuff */}
                        <CFormGroup row>
                          <CCol md="3">
                            <CLabel>
                              Please select the column that uniquely identifies
                              the data
                              {uploadType === "detail" &&
                                " and should be used to join these details onto the existing records"}
                            </CLabel>
                          </CCol>
                          <CCol md="9">
                            {csvUploadData.columns.map((column, index) => {
                              return (
                                <CFormGroup variant="checkbox" key={index}>
                                  <CInputRadio
                                    className="form-check-input"
                                    id={"radio" + index}
                                    name="radios"
                                    value={column}
                                    onChange={(e) => {
                                      setUniqueIdColumn(e.target.value);
                                    }}
                                  />
                                  <CLabel
                                    variant="checkbox"
                                    htmlFor={"radio" + index}
                                  >
                                    {column}
                                  </CLabel>
                                </CFormGroup>
                              );
                            })}
                          </CCol>
                        </CFormGroup>
                      </CForm>
                    </CCardBody>
                    <CCardFooter>
                      <CButton
                        color="success"
                        data-attr="datasets:btn:complete-data-upload"
                        disabled={
                          !uniqueIdColumn ||
                          (uploadType === "detail" &&
                            (!updateDetailColumnName ||
                              updateDetailColumnName === ""))
                        }
                        onClick={() => {
                          setSyncCsvData(null);
                          setIsSyncCsvDataLoading(true);
                          setSyncCsvDataStatus("loading");
                          setIsSyncCsvDataError(false);
                          setSyncCsvDataError(null);
                          if (uploadType === "primary") {
                            syncCsv(
                              props.datasetId || dataset_id,
                              csvUploadData.temp_file_id,
                              uniqueIdColumn,
                              (response) => {
                                // success
                                setSyncCsvData(response.data);
                                setIsSyncCsvDataLoading(false);
                                setSyncCsvDataStatus("success");
                                setIsSyncCsvDataError(false);
                                setSyncCsvDataError(null);
                                // Search indexing happens automatically in background
                              },
                              (error) => {
                                // error
                                setSyncCsvData(null);
                                setIsSyncCsvDataLoading(false);
                                setSyncCsvDataStatus("error");
                                setIsSyncCsvDataError(true);
                                setSyncCsvDataError(
                                  error?.response?.data?.detail,
                                );
                              },
                            );
                          } else if (uploadType === "detail") {
                            syncCsvDetails(
                              dataset_id,
                              csvUploadData.temp_file_id,
                              uniqueIdColumn,
                              updateDetailColumnName,
                              (response) => {
                                // success
                                setSyncCsvData(response.data);
                                setIsSyncCsvDataLoading(false);
                                setSyncCsvDataStatus("success");
                                setIsSyncCsvDataError(false);
                                setSyncCsvDataError(null);
                                // Search indexing happens automatically in background
                              },
                              (error) => {
                                // error
                                setSyncCsvData(null);
                                setIsSyncCsvDataLoading(false);
                                setSyncCsvDataStatus("error");
                                setIsSyncCsvDataError(true);
                                setSyncCsvDataError(
                                  error?.response?.data?.detail,
                                );
                              },
                            );
                          }
                        }}
                      >
                        Complete data upload!
                      </CButton>
                    </CCardFooter>
                  </>
                )}
              {isSyncCsvDataError && (
                <CAlert color="danger">{String(syncCsvDataError)}</CAlert>
              )}
              {syncCsvDataStatus === "success" && (
                <>
                  <CCardBody>
                    <h3>Data successfully uploaded!</h3>
                    <ul>
                      <li>
                        <h4>
                          {Array.isArray(syncCsvData.inserted)
                            ? syncCsvData.inserted.length
                            : syncCsvData.inserted}{" "}
                          rows inserted
                        </h4>
                      </li>
                      <li>
                        <h4>
                          {Array.isArray(syncCsvData.upsert_success)
                            ? syncCsvData.upsert_success.length
                            : syncCsvData.upsert_success}{" "}
                          rows updated
                        </h4>
                      </li>
                      <li>
                        <h4>
                          {Array.isArray(syncCsvData.upsert_failed)
                            ? syncCsvData.upsert_failed.length
                            : syncCsvData.upsert_failed}{" "}
                          rows failed
                        </h4>
                      </li>
                    </ul>
                  </CCardBody>
                  <CCardFooter>
                    <CButton
                      color="info"
                      href={""}
                      style={{ marginRight: "8px" }}
                      onClick={navigateToDataset}
                      data-attr="datasets:btn:view-dataset-after-upload"
                    >
                      View dataset
                    </CButton>
                    <CButton
                      color="info"
                      variant="outline"
                      href={""}
                      data-attr="datasets:btn:upload-more-data"
                      onClick={() => {
                        window.location.reload(false);
                      }}
                    >
                      Upload more data
                    </CButton>
                    {(props.onDoneClick || props.doneCallback) && (
                      <CButton
                        color="success"
                        href={""}
                        style={{ marginLeft: "10px" }}
                        onClick={() => {
                          if (props.onDoneClick) {
                            props.onDoneClick();
                          }
                          if (props.doneCallback) {
                            setTimeout(() => {
                              props.doneCallback();
                            }, 100);
                          }
                        }}
                      >
                        Done
                      </CButton>
                    )}
                  </CCardFooter>
                </>
              )}
            </div>
          </LoadingOverlay>
        )}
        no={() => (
          <CCardBody>
            You do not have permission to upload data to this dataset.
          </CCardBody>
        )}
      />
    </CCard>
  );
};

TabularFileUploader.propTypes = {
  titleHide: PropTypes.bool,
  datasetId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  dataset: PropTypes.object,
  onDoneClick: PropTypes.func,
  doneCallback: PropTypes.func,
};

export default TabularFileUploader;
